import React from 'react';

export interface Props extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  degrees: number;
}

export const Rotate: React.FC<Props> = ({ children, degrees, className }) => (
  <span className={className} style={{ transform: `rotate(${degrees}deg)` }}>
    {children}
  </span>
);
